import React from 'react';
import PropTypes from 'prop-types';
import StudentIcon from 'assets/layout/empty-data/student-icon.svg?url';
import TeacherIcon from 'assets/layout/empty-data/teacher-icon.svg?url';
import * as S from './ResponseDataHandle.styles';
import i18n from 'i18next';

const getIconByType = (iconType) => {
  switch (iconType) {
    case 'student':
      return StudentIcon;
    case 'teacher':
      return TeacherIcon;
    default:
      return StudentIcon;
  }
};

const ResponseDataHandleEmpty = ({
  iconType = 'student',
  hasFilters = false,
  ...props
}) => (
  <S.Container {...props}>
    <S.Image src={getIconByType(iconType)} />
    <S.Title>{i18n.t('commons.tables.empty-data.title')}</S.Title>
    <S.Description>
      {i18n.t(
        hasFilters
          ? 'commons.tables.empty-data.subtitle-filtered'
          : 'commons.tables.empty-data.subtitle'
      )}
    </S.Description>
  </S.Container>
);

ResponseDataHandleEmpty.propTypes = {
  iconType: PropTypes.string,
  hasFilters: PropTypes.bool,
};

export default ResponseDataHandleEmpty;
